<p-select [options]="locales()" [ngModel]="selected()" (ngModelChange)="setSelected($event)">
  <ng-template #selectedItem>
    <div class="flex">
      <img src="/flag_placeholder.png" alt="" [class]="'flag flag-' + selected()" />
    </div>
  </ng-template>
  <ng-template let-country #item>
    <div class="flex">
      <img src="/flag_placeholder.png" alt="" [class]="'flag flag-' + country" />
    </div>
  </ng-template>
</p-select>
